export default __webpack_public_path__ + "static/media/has-notifications-icon.e1fb92bf.svg";